import cookie from "cookie";

const CACHE_KEY = "refreshToken";

const clearRefreshTokenCache = () => {
  localStorage.removeItem(CACHE_KEY);
  document.cookie = `${CACHE_KEY}=; Max-Age=-99999999;`;
};

const getRefreshTokenCache = (): string | undefined => {
  try {
    const fromStorage = localStorage.getItem(CACHE_KEY);
    if (fromStorage) {
      return fromStorage;
    }
  } catch (e) {}
  try {
    const c = cookie.parse(document.cookie);
    if (c?.[CACHE_KEY]) {
      return c[CACHE_KEY];
    }
  } catch (e) {}
  return undefined;
};

const setRefreshTokenCache = (refreshToken: string): void => {
  localStorage.setItem(CACHE_KEY, refreshToken);
  document.cookie = cookie.serialize(CACHE_KEY, refreshToken, {
    maxAge: 7 * 24 * 60 * 60, // 7 days
  });
};

export { clearRefreshTokenCache, getRefreshTokenCache, setRefreshTokenCache };
